export default (min: number, max: number, decimals: number = 0): number => {
    if (min > max) {
        throw new Error("The minimum value cannot be greater than the maximum value.");
    }

    if (decimals < 0) {
        throw new Error("The number of decimal places must be non-negative.");
    }

    const randomNum = Math.random() * (max - min) + min;
    return parseFloat(randomNum.toFixed(decimals));
}